module.exports = __webpack_public_path__ + "media/images/ui-dark-d1ba0cb4.jpg";